import { TagIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const ShoppingTag = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', ...rest } = props;

  return <TagIcon size={Sizes[size]} {...rest} color={fill} />;
};

ShoppingTag.displayName = 'ShoppingTag';
